const applets = [
    {
        "text": "Inbox",
        "icon": "/image/myFavorite/inbox.svg",
        "path": "inbox",
        "id": "Inbox",
        "disabled": true,
        "category": "My Favorite"
    },
    {
        "text": "Assessment Review Meeting",
        "icon": "/image/myFavorite/meeting.svg",
        "path": "assessmentReviewMeeting",
        "id": "AssessmentReviewMeeting",
        "category": "My Favorite"
    },
    {
        "text": "Market Test",
        "icon": "/image/assessmentManagement/market.svg",
        "path": "marketTestInbox",
        "id": "MarketTestInbox",
        "category": "My Favorite"
    },
    {
        "text": "Overdue Application",
        "icon": "/image/myFavorite/overdue.svg",
        "path": "overdueApplicationInbox",
        "id": "OverdueApplicationInbox",
        "category": "My Favorite"
    },
    {
        "text": "Assessment Data",
        "icon": "/image/assessmentManagement/evaluation-2.svg",
        "path": "assessmentData",
        "id": "AssessmentData",
        "category": "Assessment Management"
    },
    {
        "text": "Irregular Application",
        "icon": "/image/myFavorite/search.svg",
        "path": "irregularApplication",
        "id": "IrregularApplication",
        "category": "Assessment Management"
    },
    {
        "text": "Market Test",
        "icon": "/image/assessmentManagement/market.svg",
        "path": "marketTest",
        "id": "MarketTest",
        "category": "Assessment Management"
    },
    {
        "text": "Registration Management",
        "icon": "/image/assessmentManagement/applicationManagement.svg",
        "path": "registrationManagement",
        "id": "RegistrationManagement",
        "category": "Assessment Management"
    },
    {
        "text": "Application Management",
        "icon": "/image/assessmentManagement/applicationManagement.svg",
        "path": "applicationManagement",
        "id": "ApplicationManagement",
        "category": "Assessment Management"
    },
    {
        "text": "Customer Management",
        "icon": "/image/assessmentManagement/people.svg",
        "path": "customerManagement",
        "id": "CustomerManagement",
        "category": "Assessment Management"
    },
    {
        "text": "Application Processing",
        "icon": "/image/assessmentManagement/dossier.svg",
        "path": "applicationProcessing",
        "id": "ApplicationProcessing",
        "category": "Assessment Management"
    },
    {
        "text": "Application Management (Leezen)",
        "icon": "/image/reportFormManagement/leezen.svg",
        "path": "leezenApplicationManagement",
        "id": "LeezenApplicationManagement",
        "category": "Assessment Management"
    },
    {
        "text": "Customer Management (Leezen)",
        "icon": "/image/reportFormManagement/leezenCustomer.svg",
        "path": "leezenCustomerManagement",
        "id": "LeezenCustomerManagement",
        "category": "Assessment Management"
    },
    {
        "text": "Change Inspector",
        "icon": "/image/assessmentManagement/change.svg",
        "path": "changeInspector",
        "id": "ChangeInspector",
        "category": "Assessment Management"
    },
    {
        "text": "Leezen Report Form",
        "icon": "/image/reportFormManagement/leezen.svg",
        "path": "leezenReportForm",
        "id": "LeezenReportForm",
        "category": "Report Form Management"
    },
    {
        "text": "Customer List Book",
        "icon": "/image/assessmentManagement/people.svg",
        "path": "customerList",
        "id": "CustomerList",
        "category": "Report Form Management"
    },
    {
        "text": "Product One Look List",
        "icon": "/image/reportFormManagement/product.svg",
        "path": "productList",
        "id": "ProductList",
        "category": "Report Form Management"
    },
    {
        "text": "Food Safety Incident List",
        "icon": "/image/reportFormManagement/foodSafety.svg",
        "path": "foodSafetyIncident",
        "id": "FoodSafetyIncident",
        "category": "Report Form Management"
    },
    {
        "text": "Product Raw Material Detail List",
        "icon": "/image/reportFormManagement/ingredient.svg",
        "path": "rawMaterialList",
        "id": "RawMaterialList",
        "category": "Report Form Management"
    },
    {
        "text": "Ncr One Look List",
        "icon": "/image/reportFormManagement/x.svg",
        "path": "ncrList",
        "id": "NcrList",
        "category": "Report Form Management"
    },
    {
        "text": "KPI",
        "icon": "/image/reportFormManagement/kpi.svg",
        "path": "kpi",
        "id": "KPI",
        "category": "Report Form Management"
    },
    {
        "text": "Inspector KPI",
        "icon": "/image/reportFormManagement/kpi.svg",
        "path": "inspectorKpi",
        "id": "InspectorKpi",
        "category": "Report Form Management"
    },
    {
        "text": "Account Statement",
        "icon": "/image/reportFormManagement/accounts.svg",
        "path": "accountStatement",
        "id": "AccountStatement",
        "category": "Report Form Management"
    },
    {
        "text": "Test One Look List",
        "icon": "/image/reportFormManagement/foodTest.svg",
        "path": "testList",
        "id": "TestList",
        "category": "Report Form Management"
    },
    {
        "text": "Account",
        "icon": "/image/system/account.svg",
        "id": "Account",
        "path": "account",
        "category": "System"
    },
    {
        "text": "DeputyByRoles",
        "icon": "/image/system/deputy.svg",
        "id": "DeputyByRoles",
        "path": "deputyByRoles",
        "category": "System"
    },
    {
        "text": "Workflow Role",
        "icon": "/image/assessmentManagement/people.svg",
        "id": "WorkflowRoleSetting",
        "path": "workflowRoleSetting",
        "category": "System"
    },
    {
        "text": "Letter Template",
        "icon": "/image/system/letter-template.svg",
        "id": "LetterTemplate",
        "path": "letterTemplate",
        "category": "System"
    },
    {
        "text": "Activity Processing Day",
        "icon": "/image/system/calendar.svg",
        "id": "ActivityProcessingDay",
        "path": "activityProcessingDay",
        "category": "System"
    },
    {
        "text": "Checklist",
        "icon": "/image/system/checklist.svg",
        "id": "Checklist",
        "path": "checklist",
        "category": "System"
    },
    {
        "text": "Food Additive",
        "icon": "/image/system/foodAdditive.svg",
        "id": "FoodAdditive",
        "path": "foodAdditive",
        "category": "System"
    },
    {
        "text": "Organization",
        "icon": "/image/system/company.svg",
        "id": "Organization",
        "path": "organization",
        "category": "System"
    },
    {
        "text": "System Code",
        "icon": "/image/system/system-code.svg",
        "id": "SystemCodeApplet",
        "path": "systemCode",
        "category": "System"
    }
]


export default applets;